import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from './api';

const SinglePost = () => {
    const { id } = useParams();  // Get post ID from URL
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await API.get(`posts/${id}/`);
                setPost(response.data);
                setLoading(false);
            } catch (err) {
                setError('Failed to load the post');
                setLoading(false);
            }
        };

        fetchPost();
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="single-post-container">
            <h1>{post.title}</h1>
            <p className="author"><strong>By:</strong> {post.username}</p>
            <p>{post.content}</p>
            <footer><small>Created at: {new Date(post.created_at).toLocaleString()}</small></footer>
        </div>
    );
};

export default SinglePost;
